export default __webpack_public_path__ + "static/media/feelingProud.288e616f.svg";